import React, { useState, useEffect } from "react";
import { Box, TextField, Typography } from "@mui/material";
import "./Edit.css";
import axios from "axios";
import { TableContainer, Paper } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiService from "../../utils/apiservice";

const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const EditDevice = ({ open, onClose, device, onSave }) => {

  const [deviceData, setDeviceData] = useState({
    device_name: "",
    imeiNumber: "",
    latitude: "",
    longitude: "",
  });

  const [errors, setErrors] = useState({});

  // ✅ Regex
  const deviceNameRegex = /^[A-Za-z0-9]+( [A-Za-z0-9]+)*$/;
  const imeiRegex = /^[0-9]{15}$/;
  const coordinateRegex = /^-?\d+(\.\d{1,6})?$/;

  useEffect(() => {
    if (open && device) {
      setDeviceData({
        device_name: device.device_name || "",
        imeiNumber: device.imeiNumber || "",
        latitude: device.latitude || "",
        longitude: device.longitude || "",
      });
      setErrors({});
    }
  }, [open, device]);

  useEffect(() => {
    if (!open) {
      setDeviceData({
        device_name: "",
        imeiNumber: "",
        latitude: "",
        longitude: "",
      });
      setErrors({});
    }
  }, [open]);

  // ✅ Runtime validation
  const validateField = (name, value) => {
    let error = "";

    if (name === "device_name") {
      if (!value) {
        error = "Device name is required";
      } else if (value.length < 2 || value.length > 30) {
        error = "Must be 2–30 characters";
      } else if (!deviceNameRegex.test(value)) {
        error =
          "Only letters & numbers, extra space is not allowed";
      }
    }

    if (name === "imeiNumber") {
      if (value && !imeiRegex.test(value)) {
        error = "IMEI must be exactly 15 digits";
      }
    }
     if (name === "latitude") {
    if (!value) {
      error = "Latitude is required";
    } else if (!coordinateRegex.test(value)) {
      error = "Max 6 digits allowed after decimal";
    } else if (parseFloat(value) < -90 || parseFloat(value) > 90) {
      error = "Latitude must be between -90 and 90";
    }
  }

  // ✅ Longitude validation
  if (name === "longitude") {
    if (!value) {
      error = "Longitude is required";
    } else if (!coordinateRegex.test(value)) {
      error = "Max 6 digits allowed after decimal";
    } else if (parseFloat(value) < -180 || parseFloat(value) > 180) {
      error = "Longitude must be between -180 and 180";
    }
  }

    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    // ✅ Fix spaces for device name
    if (name === "device_name") {
      updatedValue = value
        .replace(/\s+/g, " ")
        .replace(/^\s/, "");
    }

    setDeviceData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    // ✅ Real-time validation
    const error = validateField(name, updatedValue);

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const validateForm = () => {
    const tempErrors = {};
    const { device_name, imeiNumber, latitude, longitude } = deviceData;

    // Device name
    if (!device_name || device_name.length < 2 || !deviceNameRegex.test(device_name)) {
      tempErrors.device_name = "Invalid device name";
      toast.error(tempErrors.device_name);
    }

    // IMEI
    if (imeiNumber && !imeiRegex.test(imeiNumber)) {
      tempErrors.imeiNumber = "IMEI must be exactly 15 digits";
      toast.error(tempErrors.imeiNumber);
    }

    // Latitude (UNCHANGED)
   // Latitude
if (!latitude) {
  tempErrors.latitude = "Latitude is required";
  toast.error(tempErrors.latitude);
} else if (!coordinateRegex.test(latitude)) {
  tempErrors.latitude = "Max 6 digits allowed after decimal";
  toast.error(tempErrors.latitude);
} else if (
  parseFloat(latitude) < -90 ||
  parseFloat(latitude) > 90
) {
  tempErrors.latitude = "Latitude must be between -90 and 90";
  toast.error(tempErrors.latitude);
}

// Longitude
if (!longitude) {
  tempErrors.longitude = "Longitude is required";
  toast.error(tempErrors.longitude);
} else if (!coordinateRegex.test(longitude)) {
  tempErrors.longitude = "Max 6 digits allowed after decimal";
  toast.error(tempErrors.longitude);
} else if (
  parseFloat(longitude) < -180 ||
  parseFloat(longitude) > 180
) {
  tempErrors.longitude = "Longitude must be between -180 and 180";
  toast.error(tempErrors.longitude);
}

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const token = localStorage.getItem("accessToken");

      // const response = await axios({
      //   url: `${API_URL}/api/update_device/${device.device_id}/`,
      //   method: "POST",
      //   headers: {
      //     Authorization: `Bearer ${token}`,
      //     Accept: "application/json",
      //     "Content-Type": "application/json",
      //   },
      //   data: deviceData,
      // });
      const response = await apiService({
        url: `/api/update_device/${device.device_id}/`,
        method: "POST",
        data: deviceData,
      });

      const msg = response.data?.message || "Device updated successfully!";
      toast.success(msg);

      onSave({
        ...device,
        ...deviceData,
      });

      onClose();

    } catch (error) {
      const backendMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Failed to update device";

      toast.error(backendMessage);
    }
  };

  return (
    <>
      {open && (
        <div className="edit-site-modal">
          <Box
            component="form"
            className="edit-site-container edit-site-form"
            onSubmit={handleSubmit}
          >
            <Typography className="edit-site-title">Edit Device</Typography>

            <TextField
              label="Device Name"
              name="device_name"
              value={deviceData.device_name}
              onChange={handleChange}
              error={!!errors.device_name}
              helperText={errors.device_name || ""}
            />

            {/* ✅ IMEI FIELD */}
            {/* <TextField
              label="IMEI Number (Optional)"
              name="imeiNumber"
              value={deviceData.imeiNumber}
              onChange={handleChange}
              error={!!errors.imeiNumber}
              helperText={errors.imeiNumber || ""}
            /> */}

            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
              <TextField
                fullWidth
                type="number"
                label="Latitude"
                name="latitude"
                required
                value={deviceData.latitude}
                onChange={handleChange}
                error={!!errors.latitude}
                helperText={errors.latitude || ""}
              />

              <TextField
                fullWidth
                type="number"
                label="Longitude"
                name="longitude"
                required
                value={deviceData.longitude}
                onChange={handleChange}
                error={!!errors.longitude}
                helperText={errors.longitude || ""}
              />
            </Box>

            <div className="edit-btn-wrapper">
              <button type="button" className="cancel-btn" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="edit-btn">
                Save Changes
              </button>
            </div>
          </Box>
        </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} theme="light" />
    </>
  );
};

export default EditDevice;